import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from "ag-grid-react";
import _ from "lodash";
import "../../../common/style.css";
import {
  ColumnResizedEvent,
  FilterChangedEvent,
  FilterModifiedEvent,
  GridApi,
} from "ag-grid-community";
import "ag-grid-enterprise";
import Customtooltip from "../../../components/CustomTooltip/index";
import { onGridSizeChanged } from "../../../components/AgGrid/grid-util";
import { constants } from "../../../common/constants";
import { getRowStyle } from "../../../common/commonFunctions";
import { RecallActivityDefs } from "../../../common/columnRecallActivity";

interface AgGridProps {
  title?: string;
  rowData: any;
  height?: any;
  onClickHan?: any;
  onClickSelectData?: any;
  onCellChange?: any;
  seTtotalSelectedRows?: any;
  getBtnRef?: any;
  getGridApi?: any;
  doesExternalFilterPass?: any;
  isExternalFilterPresent?: any;
  isDeselectAll?: boolean;
  getContextMenuItems?: any;
  globalSearch?: any;
  isSingleRowInserted?: boolean;
  defaultFilter?: any;
  filters?: any;
  onRowSelected?: any;
}

const RecallActivityGrid = ({
  title,
  rowData,
  height,
  onCellChange,
  getBtnRef,
  getGridApi,
  doesExternalFilterPass,
  isExternalFilterPresent,
  isDeselectAll,
  getContextMenuItems,
  globalSearch,
  isSingleRowInserted,
  defaultFilter,
  filters,
  onRowSelected,
}: // onBtExport,
  AgGridProps) => {
  const gridRef = useRef<any>(null);
  const [columnDefs] = useState<any>([...RecallActivityDefs]);

  let gridApi: any;
  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: true,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      tooltipComponent: Customtooltip,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        let isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();
        return false;
      },
    };
  }, []);

  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  useEffect(() => {
    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    getUpdatedData(rowData);
   // getBtnRef(gridRef);
    getName(gridApi, gridColumnApi);
  }, [rowData]);

  const onColumnResized = useCallback((params: ColumnResizedEvent) => { }, []);

  const getUpdatedData = useCallback(
    async (data: any) => {
      await gridApi?.applyTransactionAsync(
        { update: [rowData] },
      );
      if (gridRef && gridRef?.current && gridRef?.current!.api) {
      }
    },
    [rowData]
  );

  useEffect(() => {
    if (defaultFilter && gridRef) {
      const filterComponent = gridRef?.current?.api?.getFilterInstance(
        defaultFilter.column
      );
      if (filterComponent) {
        filterComponent?.setModel({ values: defaultFilter.values });
        gridApi.onFilterChanged();
      }
    }
  }, [gridRef]);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
    gridApi = params.api;

    var gridColumnApi = params.columnApi;
    // Emmits the gridApi refrence to the parent component
    //if (getGridApi) {
     // getGridApi(gridApi, gridColumnApi);
    //}
  };

  /**
   * Executes whenever Grid/Table filter modifies - this is more sensitive
   * @param params
   */
  const onFilterModified = (params: FilterModifiedEvent) => {
    const { api, columnApi } = params;
  };

  /**
   * Executes whenever Grid/Table filter changes
   * @param params
   */
  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    getName(api, columnApi);
  };

  const onFirstDataRendered = () => {
    let gridColumnApi = gridRef?.current!.columnApi;
    let gridRefApi = gridRef?.current!.api;
    getName(gridRefApi, gridColumnApi);
  }

  /**
   * To skip pinned rows on the basis of Page path
   * @returns shouldSkip : boolean
   */
  const skipPinnedRow = (): boolean => {
    return false;
  };

  const getName = (api: any, columnApi: any) => {
    if (!api || !columnApi || skipPinnedRow()) return;
    let rows: any = {};
    var result = [];
    columnApi?.getAllGridColumns().forEach((item: any) => {
      rows[item.colId] = null;
    });
    let columnsWithAggregation = [
      "quantity",
      "return_qty",
      "sod_loan_qty"
    ];
    columnsWithAggregation.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        if (rowNode && rowNode.data && rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });
    let contractIdTotal = ["contract_id"];
    let countContractId_ = 0;
    contractIdTotal.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        countContractId_++;
        if (rowNode && rowNode.data && rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });
    rows["contract_id"] = countContractId_;
    var count = Number(2);
    // for (var i = 0; i < count; i++) {
    //   if (i === 0) {
    //     result.push({
    //       isTotalRow: true,
    //       contract_id: "Total Contracts",
    //       cpty_id: "Total CPTY",
    //       ticker: "Total Symbol",
    //       quantity: "Total Recall Qty",
    //       return_qty: "Total Return Qty",
    //       sod_loan_qty:"Total SOD Loan Qty"
    //     });
    //   } else {
    //     rows["isTotalRow"] = true;
    //     rows["ticker"] = countUnique("ticker", api);
    //     rows["cpty_id"] = countUnique("cpty_id", api);
    //     result.push(rows);
    //   }
    // }
    // api?.setPinnedBottomRowData(result);
  };

  /**
   * Method counts the unique value for given attribute (for filtered values also)
   * @param attribute
   * @returns unique values count
   */
  const countUnique = (attribute: string, api: GridApi): number => {
    const uniqueItemsSet: Set<any> = new Set();
    api?.forEachNodeAfterFilter((rowNode: any) => {
      if (rowNode?.data instanceof Object && attribute in rowNode.data) {
        uniqueItemsSet.add(rowNode.data[attribute]);
      }
    });
    return uniqueItemsSet.size;
  };


  useEffect(() => {
    if (isDeselectAll != undefined) gridRef.current?.api?.deselectAll();
  }, [isDeselectAll]);

  const rowClassRules = useMemo(() => {
    return {
      "is-new-warning": (params: any) => {
        var isNew = params && params.data && params.data.is_new;
        return isNew === "TRUE";
      },
      "is-new-recall": (params: any) => {
        var isNew = params && params.data && params.data.is_Recall;
        return isNew === "True";
      },
    };
  }, []);

  const onSelectionChanged = useCallback((params: any) => {
    const selectedRows = gridRef.current!.api.getSelectedNodes();
    if (!_.isEmpty(selectedRows)) {
      if (selectedRows[0].data.ticker)
        onRowSelected(selectedRows[0].data.ticker);
    }
  }, []);

  const onCellValueChanged = useCallback((event: any) => {
    let updateArray: any = [];
    event.value = event.value.toUpperCase();
    onCellChange(event.data, event.value, event.column);
    updateArray.push(event.data);

    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    gridApi?.applyTransaction({ update: updateArray });
    var params = {
      force: true,
      suppressFlash: true,
      columns: [event.column],
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 100,
      maxWidth: 200,
    };
  }, []);

  const getRowId = useMemo(() => {
    return (params: any) => (params.data?.refMsgId);
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  function isForceRefreshSelected() {
    return (document.querySelector("#forceRefresh") as HTMLInputElement)
      ?.checked;
  }
  function isSuppressFlashSelected() {
    return (document.querySelector("#suppressFlash") as HTMLInputElement)
      ?.checked;
  }
  const onGridRowDataChanged = (params: any) => {
    let refreshParams: any = {
      force: isForceRefreshSelected(),
      suppressFlash: isSuppressFlashSelected(),
    };
    gridRef.current!.api.refreshCells(refreshParams);
    setTimeout(() => {
      if (gridRef && gridRef?.current && gridRef?.current!.api) {
        if (filters) {
          if (gridApi?.getFilterModel() !== filters)
            gridApi?.setFilterModel(filters);
        }
      }
    }, 500);
  };

  const onCellFocused = (event: any) => {
    if (event && !_.isUndefined(event?.rowIndex) && !_.isNull(event?.rowIndex)) {
      let rowNode = gridRef?.current?.api?.getDisplayedRowAtIndex(event?.rowIndex);
      if (rowNode && event?.rowPinned !== "bottom") {
        const selected: any = [];
        selected.push(rowNode);
        gridRef?.current?.api?.setNodesSelected({ nodes: selected, newValue: true });
      }
    }
  }

  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  const onDoesfilter = useCallback((node: any) => {
    doesExternalFilterPass(node);
    return true;
  }, []);

  return (
    <>
      {title !== undefined && (
        <div
          style={{ height: "3.5%" }}
          className="drag-handle title-subHeaderTitle"
        >
          {title}
        </div>
      )}
      <div className="ag-theme-balham" style={{ height: `${height}vh`, }}>
        <AgGridReact
          ref={gridRef}
          rowStyle={{
            justifyContent: "center",
            color: "#2D2D2D",
            fontSize: "0.75rem",
            fontWeight: "400",
            fontStyle: "normal",
          }}
          rowHeight={22}
          columnDefs={columnDefs}
          getRowId={getRowId}
          onFirstDataRendered={onFirstDataRendered}
          onRowDataUpdated={onGridRowDataChanged}
          rowData={rowData}
          rowSelection={"single"}
          onCellFocused={onCellFocused}
          onSelectionChanged={onSelectionChanged}
          defaultColDef={defaultColDef}
          suppressAggFuncInHeader={true}
          enableCellChangeFlash={
            _.isUndefined(isSingleRowInserted) || !isSingleRowInserted
          }
          enableRangeSelection={true}
          onGridReady={onGridReady}
          onFilterModified={onFilterModified}
          onFilterChanged={onFilterChanged}
          onGridSizeChanged={onGridSizeChanged}
          onColumnResized={onColumnResized}
          rowClassRules={rowClassRules}
          getRowStyle={getRowStyle}
          onCellValueChanged={onCellValueChanged}
          autoGroupColumnDef={autoGroupColumnDef}
          groupSelectsChildren={true}
          groupSelectsFiltered={true}
          sideBar={sideBar}
          pivotMode={false}
          cacheQuickFilter={false}
          isExternalFilterPresent={isExternalFilterPresent}
          doesExternalFilterPass={onDoesfilter}
          getContextMenuItems={getContextMenuItems}
          quickFilterText={globalSearch}
          overlayLoadingTemplate={
            '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          }
        ></AgGridReact>
      </div >
    </>
  );
};

function CustomTooltip() { }

CustomTooltip.prototype.init = function (params: any) {
  var type = params.type || "primary";
  var data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  var eGui = (this.eGui = document.createElement("div"));

  eGui.classList.add("custom-tooltip");
  this.eGui.innerHTML =
    '<div class="panel panel-' +
    type +
    '">' +
    '<div class="panel-heading">' +
    '<h3 class="panel-title">' +
    data.country +
    "</h3>" +
    "</div>" +
    '<div class="panel-body">' +
    '<h4 style="white-space: nowrap;">' +
    data.athlete +
    "</h4>" +
    "<p>Total: " +
    data.total +
    "</p>" +
    "</div>" +
    "</div>";
};

CustomTooltip.prototype.getGui = function () {
  return this.eGui;
};

export default RecallActivityGrid;
